import React from "react";
import LoginForm from "../layout/LoginForm";

const LoginPage = ({
  onSuccess,
  setAccessUpdated,
  accessUpdated,
  sharedLink,
}) => {
  return (
    <div className="pt-24">
      <LoginForm
        setAccessUpdated={setAccessUpdated}
        accessUpdated={accessUpdated}
        onSuccess={onSuccess}
        sharedLink={sharedLink}
      />
    </div>
  );
};

export default LoginPage;
